<template>
    <div class="w-full h-16 text-center"
        :class=" {'opacity-50': player.dead }"
        @click="$emit('select')">
        <div class="transition-all  w-full h-full duration-500 mx-auto">
            <div class="bg-gray-800 h-full w-full text-xl pt-4 rounded-lg items-center">
                {{player.name}}
                <button v-if="!player.dead" class="absolute right-0 mr-5" @click.stop="$emit('dead')">
                    <i class="text-red-400 fas fa-skull"></i>
                </button>
                <button v-else class="absolute right-0 mr-5" @click.stop="$emit('alive')">
                    <i class="text-green-400 fas fa-heart"></i>
                </button>
            </div>

        </div>
    </div>
</template>
<script>
export default {
    props: ['player'],
}
</script>